// eslint-disable-next-line
export default [];



// WEBPACK FOOTER //
// ./config-bb-module-loader/scripts/bundle.js